import React from 'react';
import { ELIGIBILITY_QUESTIONS } from 'components/EnrollmentV2/constants/eligibility';
import { translateBool } from 'components/EnrollmentV2/util/translation';

const ReviewEligibility = ({ state }) => {
    const eligibilityKeys = Object.keys(ELIGIBILITY_QUESTIONS);
    const MIDPOINT_INDEX = Math.ceil(eligibilityKeys.length / 2);
    return (
        <div className="row">
            <div className="col-md-5">
                <ul>
                    {eligibilityKeys
                        .slice(0, MIDPOINT_INDEX)
                        .map((keyValue, index) => {
                            return (
                                <li key={`previewEllig_${index}`}>
                                    <div>{ELIGIBILITY_QUESTIONS[keyValue]}</div>
                                    <div>
                                        <strong>
                                            {translateBool(
                                                state?.enrollment.page4.sub3
                                                    .questions[index].response
                                            )}
                                        </strong>
                                    </div>
                                </li>
                            );
                        })}
                </ul>
            </div>
            <div className="col-md-5">
                <ul>
                    {eligibilityKeys
                        .slice(MIDPOINT_INDEX)
                        .map((keyValue, index) => {
                            return (
                                <li key={`previewEllig_${index}`}>
                                    <div>{ELIGIBILITY_QUESTIONS[keyValue]}</div>
                                    <div>
                                        <strong>
                                            {translateBool(
                                                state?.enrollment.page4.sub3
                                                    .questions[
                                                    index + MIDPOINT_INDEX
                                                ].response
                                            )}
                                        </strong>
                                    </div>

                                    {keyValue === 'enrolledStateMedicaid' &&
                                        state?.enrollment.page4.sub3.questions[
                                            index + MIDPOINT_INDEX
                                        ]?.response && (
                                            <div>
                                                Medicaid ID:
                                                <strong>
                                                    {state?.enrollment.page4
                                                        .sub3.questions[
                                                        index + MIDPOINT_INDEX
                                                    ]?.additionalQuestions[0]
                                                        ?.response || 'N/A'}
                                                </strong>
                                            </div>
                                        )}
                                </li>
                            );
                        })}
                </ul>
            </div>
        </div>
    );
};
export default ReviewEligibility;
